import { useMutation } from '../../index';
import permissions from '../../Apollo/permissions';
import { validate } from 'parameter-validator';
import { useUserContext } from '@ion/user';

import {
  mutation as removePipelineMutation,
  buildVariables as buildRemovePipelineVariables,
} from './remove-pipeline-mutation-builder';

import { PIPELINES_QUERY } from 'api/pipelines/pipelines-query-builder';

export default function useRemovePipeline(options = {}) {
  const { user, currentOrg } = useUserContext();
  const userData = { email: user?.email, org: currentOrg?.display_name };
  const [executeMutation, response] = useMutation(removePipelineMutation, {
    successMsg: 'Pipeline removed.',
    context: { permission: permissions.deletePipeline },
    refetchQueries: [PIPELINES_QUERY],
    ...options,
    update: buildUpdateCache(userData),
  });

  const removePipeline = args => {
    const { pipelineId } = validate(args, ['pipelineId']);
    const variables = buildVariables({ pipelineId });
    return executeMutation(variables);
  };
  return [removePipeline, response];
}

function buildVariables({ pipelineId }) {
  return {
    variables: buildRemovePipelineVariables({ pipelineId }),
  };
}

// Remove from cache on "soft delete"
function buildUpdateCache(userData) {
  return (cache, { data }) => {
    const deletedPipeline = data.update_pipelines_by_pk;

    track({ deletedPipeline, userData });

    // remove it from cache
    cache.evict({ id: cache.identify(data.update_pipelines_by_pk) });
    cache.gc();
  };
}

function track({ deletedPipeline, userData }) {
  __mrTracking?.track('pipeline_deleted', {
    id: deletedPipeline.id,
    userEmail: userData.email,
    orgName: userData.org,
  });
}
